import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { customAxiosGetFunction } from 'utils/axiosFunction';
import { nvl } from 'utils/nvl';

export const useGraphSystemLogData = (title, logIdx) => {
  const history = useHistory();
  const [logData, setLogData] = useState(null);

  useEffect(() => {
    const getLogDataForPopupGraph = async () => {
      let url = '';

      switch (title) {
        case '체감온도':
          url = '/api/gas/newestDataOneByLogIdx';
          break;
        default:
          return;
      }

      const response = await customAxiosGetFunction(history, url, { params: { logIdx: logIdx } });
      setLogData(nvl(response, null));
    };

    getLogDataForPopupGraph();

    const timer = window.setInterval(() => {
      getLogDataForPopupGraph();
    }, Number(5000));

    return () => {
      window.clearInterval(timer);
    };
  }, []);

  return logData;
};
